<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row">
                    <div v-if="sectionTitle" class="col-12">
                        <h6 class="mb-4">{{ sectionTitle }}</h6>
                    </div>
                    <div v-if="img" class="col-12 mb-4 mb-lg-0">
                        <div class="row">
                            <div
                                class="col-12 col-lg-8 mb-1 mb-lg-0"
                                :class="position == 'left' ? '' : 'order-1 order-lg-2'"
                            >
                                <AssetLoader :asset="{ asset: img.imageID }" />
                            </div>
                            <div
                                v-if="img.imgCredits"
                                class="col-12 col-lg-4"
                                :class="position == 'left' ? '' : 'order-2 order-lg-1'"
                            >
                                <div class="text-editor image-credit pt-2" v-html="img.imgCredits"></div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="textEditor"
                        class="col-12 d-flex"
                        :class="position == 'left' ? 'justify-content-end' : 'justify-content-start'"
                    >
                        <div class="text-editor text-editor-blog" v-html="textEditor"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'textImg',
    components: {
        AssetLoader
    },
    props: {
        sectionTitle: {
            type: String,
            required: true,
        },
        textEditor: {
            type: String,
            required: true,
        },
        position: {
            type: String,
            required: true,
        },
        img: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
